import React from 'react';
import {
    Redirect,
    Route as RouteDOM,
    RouteProps as RouteDOMProps,
} from 'react-router-dom';
import { useAuth } from './context/AuthContext';

interface RouteProps extends RouteDOMProps {
    isPrivate?: boolean;
    component: React.ComponentType;
}
const crumbs: any[] = [];
const Route: React.FC<RouteProps> = ({
    isPrivate = false,
    component: Component,
    ...rest
}) => {
    const { user } = useAuth();
    return (
        <RouteDOM
            {...rest}
            render={({ location, match }) => {
                // const crumbs = routes
                //     // Get all routes that contain the current one.
                //     .filter(({ path }) => match.path.includes(path))
                //     // Swap out any dynamic routes with their param values.
                //     // E.g. "/pizza/:pizzaId" will become "/pizza/1"
                //     .map(({ path, ...rest }) => ({
                //         path: Object.keys(match.params).length
                //             ? Object.keys(match.params).reduce(
                //                   (path, param) =>
                //                       path.replace(
                //                           `:${param}`,
                //                           match.params[param],
                //                       ),
                //                   path,
                //               )
                //             : path,
                //         ...rest,
                //     }));
                crumbs.push({ path: match });
                if (!(isPrivate === !!user)) {
                    crumbs.splice(0, crumbs.length);
                }
                return isPrivate === !!user ? (
                    <Component />
                ) : (
                    <Redirect
                        to={{
                            pathname: isPrivate ? '/' : '/dashboard',
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
};

export default Route;
